import Pagination from '@mui/material/Pagination';
import { createTheme, ThemeProvider } from '@mui/material/styles';

export default function GeneralPaginator({ page, setPage, numberOfPages, setTableByPage }) {
    
    const theme = createTheme({
        palette: {
          primary: {
            main: '#00925A', // Change this to your preferred primary color
          }
        },
        typography: {
          fontFamily: 'Mulish, sans-serif', // Change the default font family
          // You can also customize other typography properties here
        },
        // You can customize other aspects of the theme such as spacing, breakpoints, etc.
      });
    
    function handleChange(event, value) {
        setPage(value)
        setTableByPage(value)
    }
    
    return (
        <ThemeProvider theme={theme}>
            <Pagination color="primary" variant="outlined" shape="rounded" page={page} onChange={handleChange} count={numberOfPages}/>
        </ThemeProvider>
    )
}